import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuMySubscriptions = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 4.00098C23.1046 4.00098 24 4.89641 24 6.00098V12.4541C24 13.4492 23.6293 14.4092 22.96 15.1455L19.7354 18.6914C18.9774 19.5252 17.9032 20.0009 16.7764 20.001H2C0.895431 20.001 0 19.1055 0 18.001V6.00098C0 4.89641 0.895431 4.00098 2 4.00098H22ZM2 5.50098C1.72386 5.50098 1.5 5.72483 1.5 6.00098V18.001C1.5 18.2771 1.72386 18.501 2 18.501H16.7764C17.4802 18.5009 18.152 18.204 18.626 17.6826L21.8496 14.1367L21.998 13.958C22.3226 13.5265 22.5 12.9988 22.5 12.4541V6.00098C22.5 5.72483 22.2761 5.50098 22 5.50098H2ZM11 7.00098C12.1046 7.00098 13 7.89641 13 9.00098V15.001C13 16.0366 12.2128 16.888 11.2041 16.9902L11 17.001H5L4.7959 16.9902C3.85435 16.8948 3.1062 16.1466 3.01074 15.2051L3 15.001V9.00098C3 7.89641 3.89543 7.00098 5 7.00098H11ZM5 8.50098C4.72386 8.50098 4.5 8.72483 4.5 9.00098V15.001C4.5 15.2771 4.72386 15.501 5 15.501H11C11.2761 15.501 11.5 15.2771 11.5 15.001V9.00098C11.5 8.72483 11.2761 8.50098 11 8.50098H5Z"
	})
});
export default SvgMenuMySubscriptions;
